<script lang="ts">
  import {t} from './i18n'
  import api from './api/api'
  import {flash} from './stores/flash'
  import ModalTemplate from './shared/ModalTemplate.svelte'
  import {modal} from './stores/modal'

  export let message = {
    name: '',
    email: '',
    content: ''
  }

  const submit = async (e: Event) => {
    e.preventDefault()
    await api.post('/contact_messages', {message})
    window.scrollTo(0, 0)
    flash.show(t.flash.contact_us.message_sent)
    modal.close()
  }
</script>

<ModalTemplate size="tiny">
  <div class="modal-content">
    <form onsubmit={submit}>
      <h2 class="reg-log-title">
        <span>{t.contact_us.title}</span>
      </h2>
      <div class="line">
        <input placeholder={t.contact_us.name.placeholder} bind:value={message.name} required/>
      </div>
      <div class="line">
        <input type="email" placeholder={t.contact_us.email.placeholder} required bind:value={message.email}/>
      </div>
      <div class="line modal-textarea">
        <textarea class="bordered" placeholder={t.contact_us.content.placeholder} bind:value={message.content}
                  required/>
      </div>
      <button type="submit" class="ui button black">
        {t.contact_us.submit}
      </button>
    </form>
  </div>
</ModalTemplate>
